import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ListItem, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useLocalizeNumberValue } from '@e3dc-react/shell/Hooks/useLocalizeNumberValue'
import { formatDuration } from '@e3dc-react/shell/Libs/date'
import { PricingInfo } from './PricingInfo'
import { ChargingSessionModelV1 } from 'src/Libs/e-mobility/charging-sessions'

const useStyles = makeStyles()(theme => ({
  listItem: {
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: 0,
  },
  listItemTitle: {
    overflowWrap: 'anywhere',
    hyphens: 'auto',
    width: '33%',
  },
  listItemValue: {
    width: '67%',
    paddingLeft: theme.spacing(1),
    overflowWrap: 'anywhere',
    hyphens: 'auto',
  },
}))

interface EdisonConnectPricingProps {
  session: ChargingSessionModelV1
  wallboxIndex: number | undefined
}

/**
 * EdisonConnectPricing component for displaying discharge values only fow EdisonConnect wallbox type
 * @param session single session as ChargingSessionModel
 * @param wallboxIndex wallbox number form wallbox hardware
 * @returns JSX component
 */
const EdisonConnectPricing: React.VFC<EdisonConnectPricingProps> = ({ session }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const localizeNumberValue = useLocalizeNumberValue()
  const dischargeEnergyKWh = session.energyDischarged / 1000
  const dischargeCost = session.dischargePrice * dischargeEnergyKWh

  return (
    <>
      <ListItem divider className={classes.listItem} disableGutters>
        <Typography variant="subtitle1" className={classes.listItemTitle}>
          {t('emobility.chargingSession.dischargedLoaded')}
        </Typography>

        <Typography variant="body2" className={classes.listItemValue}>
          {t('common.format.kwh', {
            value: localizeNumberValue(session.energyDischarged / 1000),
          })}
        </Typography>
      </ListItem>

      <ListItem divider className={classes.listItem} disableGutters>
        <Typography variant="subtitle1" className={classes.listItemTitle}>
          {t('emobility.chargingSession.dischargedDuration')}
        </Typography>
        <Typography variant="body2" className={classes.listItemValue}>
          {formatDuration(session.dischargeTimeActive)}
        </Typography>
      </ListItem>

      <ListItem className={classes.listItem} disableGutters>
        <Typography variant="subtitle1" className={classes.listItemTitle}>
          {t('emobility.chargingSession.dischargedPrice')}
        </Typography>
        <PricingInfo totalCostKWh={dischargeCost} className={classes.listItemValue} />
      </ListItem>
    </>
  )
}

export default EdisonConnectPricing
